import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { ServiceordreStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceordre-status-enum';
import { ServiceordreValidationFailedReasonEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceordre-validation-failed-reason-enum';

@Component({
    selector: 'app-validation-failed-dialog',
    templateUrl: './validation-failed-dialog.component.html',
    styleUrls: ['./validation-failed-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ValidationFailedDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ValidationFailedDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ServiceordreDto) {
    this.serviceordre = data;
  }

  private serviceordre: ServiceordreDto;

  public get isMultipleEftersyn(): boolean {
    return this.serviceordre.serviceordreValidationFailedReason == ServiceordreValidationFailedReasonEnum.MultipleEftersynInServiceInterval;
  }

  ngOnInit(): void {}

  cancel() {
    this.dialogRef.close(ServiceordreStatusEnum.Cancelled);
  }
  approve() {
    this.dialogRef.close(ServiceordreStatusEnum.ReadyForBroadcast);
  }
}
